import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';
import { useDebounce } from 'stimulus-use';

export default class extends Controller {
  static targets = ['form', 'searchIcon', 'loaderIcon'];

  static values = {
    searchPath: String,
    reportUuid: String,
  };

  static debounces = [
    { name: 'debouncedSearch', wait: 300 },
  ];

  connect() {
    useDebounce(this);

    // This fires the first request only when the element is in view
    // This prevents unnecessary request when the "Helpful Articles" tab was not even opened
    this.intersectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.debouncedSearch();
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    this.intersectionObserver.observe(this.element);

    this.boundShowSearchIcon = this.showSearchIcon.bind(this);

    document.addEventListener('turbo:before-stream-render', this.boundShowSearchIcon);
  }

  disconnect() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    document.removeEventListener('turbo:before-stream-render', this.boundShowSearchIcon);
  }

  debouncedSearch() {
    this.toggleIcons(false);
    this.sendTurboRequest();
  }

  sendTurboRequest() {
    const params = new URLSearchParams({
      report_uuid: this.reportUuidValue,
    });

    if (this.formTarget.q.value) {
      params.append('q', this.formTarget.q.value);
    }

    get(`${this.searchPathValue}?${params.toString()}`, { responseKind: 'turbo-stream' });
  }

  showSearchIcon() {
    this.toggleIcons(true);
  }

  toggleIcons(showSearchIcon) {
    this.searchIconTarget.dataset.visible = showSearchIcon;
    this.loaderIconTarget.dataset.visible = !showSearchIcon;
  }
}
